// Adds Tailwind variables to the global scope
import "./setup/tailwind-setup.js";

// Setup LordIcon - <lord-icon> element
import lottie from "lottie-web";
import { defineElement } from "lord-icon-element";
defineElement(lottie.loadAnimation);

// Import JavaScript components
// import './components/accordion';
// import './components/tabs';
// import './components/toggle';

//If you want cookie consent
// import "./modules/cookie-consent";

//If you need a class to be toggled on a different element
// import "./modules/toggle";

//If you need to do something when its in/out of the viewport
// import "./modules/intersects";

import AOS from "aos";

AOS.init();

document.getElementById("hamburgerToggle").onclick = () => {
	window.scrollTo(0, 0),
		document.getElementById("hamburger").classList.toggle("is-active"),
		document.getElementById("mobileMenu").classList.toggle("mobile-menu-active"),
		document.getElementById("mobileMenu").classList.toggle("!overflow-y-scroll"),
		document.getElementById("headerLogo").classList.toggle("mobile-menu-logo"),
		document.getElementById("menuText").classList.toggle("hidden"),
		document.getElementById("searchToggleMobile").classList.toggle("searchToggleMobile--active"),
		document.getElementById("body").classList.toggle("overflow-y-hidden");
};

document.getElementById("searchToggle").onclick = () => {
	document.getElementById("menu-main-menu").classList.toggle("!hidden");
	document.getElementById("menuSearch").classList.toggle("header-search-active");
};
document.getElementById("searchToggleClose").onclick = () => {
	document.getElementById("menu-main-menu").classList.remove("!hidden");
	document.getElementById("menuSearch").classList.remove("header-search-active");
};
document.getElementById("searchToggleMobile").onclick = () => {
	document.getElementById("menu-mobile-menu").classList.toggle("!hidden");
	document.getElementById("menuMobileSearch").classList.toggle("hidden");
	// document.getElementById("searchToggleMobile").classList.add("!hidden");
};
document.getElementById("searchToggleMobileClose").onclick = () => {
	document.getElementById("menu-mobile-menu").classList.remove("!hidden");
	document.getElementById("menuMobileSearch").classList.toggle("hidden");
	// document.getElementById("searchToggleMobile").classList.remove("!hidden");
};

const mobilelinks = document.getElementById("mobileMenu").getElementsByClassName("menu-item-has-children");

for (let i = 0; i < mobilelinks.length; i++) {
	mobilelinks[i].firstElementChild.addEventListener("click", function () {
		this.parentElement.classList.toggle("sub-menu__active");
	});
}

const backarrows = document.getElementsByClassName("sub-menu-back");

for (let i = 0; i < backarrows.length; i++) {
	backarrows[i].addEventListener("click", function () {
		this.parentElement.parentElement.parentElement.classList.toggle("sub-menu__active");
	});
}

const paneltoggle = document.getElementsByClassName("panel-btn");

for (let i = 0; i < paneltoggle.length; i++) {
	paneltoggle[i].addEventListener("click", function () {
		let siblings = this.parentElement.children;
		for (let sib of siblings) {
			sib.classList.remove("panel-btn-active");
		}
		this.classList.add("panel-btn-active");
	});
}

var containerWidth = document.querySelector(".container").offsetWidth;
var viewWidth = window.innerWidth;
var marginCalc = (viewWidth - containerWidth) / 2;

document.querySelectorAll(".carousel-overflow").forEach((element) => {
	element.style.marginLeft = `${marginCalc}px`;
});

// Filter Toggle

document.getElementById("filterToggle").onclick = () => {
	document.getElementById("filterHamburger").classList.toggle("is-active");
	document.getElementById("filter").classList.toggle("active");
};

import "./extra/app.js";